"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyTransporterToLogisticOrderQueries = void 0;
const apply_transporter_to_logistic_order_query_1 = require("./apply-transporter-to-logistic-order-query");
const applyTransporterToLogisticOrderQueries = function (logisticOrders) {
    return logisticOrders.map(logisticOrder => (0, apply_transporter_to_logistic_order_query_1.applyTransporterToLogisticOrderQuery)(logisticOrder));
};
exports.applyTransporterToLogisticOrderQueries = applyTransporterToLogisticOrderQueries;
